import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';

export const useTrackAssetModalInfoPanelOpen = () => {
  const { track } = useAnalyticsUtilities();

  const trackAssetModalInfoPanelOpen = useCallback(() => {
    track(`Opened asset modal info panel`);
  }, [track]);

  return { trackAssetModalInfoPanelOpen };
};
